import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fire-and-forget event tracking.
 * Silently swallows errors so it never blocks UI.
 */
export function trackEvent(eventType, { sessionId, userEmail, metadata } = {}) {
  axios
    .post(`${API}/events/track`, {
      event_type: eventType,
      session_id: sessionId || null,
      user_email: userEmail || null,
      metadata: metadata || {},
    })
    .catch(() => {}); // silent
}

// Convenience helpers — pass userEmail whenever the learner is authenticated so
// admin Analytics → Organizations can attribute activity to a domain (Issue 2, Aug 2026)
export const trackAssessmentViewed = (meta, userEmail) => trackEvent("assessment_viewed", { userEmail, metadata: meta });
export const trackAssessmentStarted = (meta, userEmail) => trackEvent("assessment_started", { userEmail, metadata: meta });
export const trackAssessmentCompleted = (sessionId, meta, userEmail) => trackEvent("assessment_completed", { sessionId, userEmail, metadata: meta });
export const trackPlanGenerated = (sessionId, meta, userEmail) => trackEvent("plan_generated", { sessionId, userEmail, metadata: meta });
export const trackResourceClicked = (sessionId, resourceId, userEmail) =>
  trackEvent("resource_clicked", { sessionId, userEmail, metadata: { resource_id: resourceId } });
export const trackPlanRefined = (sessionId, meta, userEmail) => trackEvent("plan_refined", { sessionId, userEmail, metadata: meta });
